import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSuitcase, faUsers } from "@fortawesome/free-solid-svg-icons";
import Wrapper from "./styles/homepage-styles";

const HomePage = ({ homepageUrl, isEmployer }) => {
  const handleLink = () => {
    window.location.href = homepageUrl;
  };

  const handleRecruiterOnClick = () => {
    window.location.href = homepageUrl;
  };

  return (
    <Wrapper
      onClick={isEmployer ? () => handleLink() : () => handleRecruiterOnClick()}
    >
      <FontAwesomeIcon icon={isEmployer ? faSuitcase : faUsers} />
    </Wrapper>
  );
};

HomePage.propTypes = {
  homepageUrl: PropTypes.string.isRequired,
  isEmployer: PropTypes.bool.isRequired,
};

export default HomePage;
